const auditStatusList = [
    {value: 0, label: '未审核'},
    {value: 1, label: '审核通过'},
    {value: 2, label: '审核拒绝'}
];

const goodsFlashSaleStatusList = [
    {value: 0, label: '已停止'},
    {value: 1, label: '已开始'}
];

export {
    auditStatusList,
    goodsFlashSaleStatusList
}